<template>
  <div>
    <div class="mx-5 py-5 d-flex justify-space-between">
      <h5>Add New User</h5>
    </div>

    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-8">
        <!-- <div class="d-flex justify-center">
          <v-card style="padding: 1%; background-color: rgb(246, 248, 252);" flat color="transparent">
            <userimageuploader-component 
              :img="User.ProfileImage"
              @setImage="SetImage"
            />
          </v-card>
        </div> -->

        <v-container class="mt-4">
          <v-text-field
            v-model="User.FirstName"
            label="First name *"
            :error-messages="
              getErrorMessage('FirstName', 'FirstName')
            "
          ></v-text-field>
          <v-text-field
            v-model="User.LastName"
            label="Last name *"
            :error-messages="
              getErrorMessage('LastName', 'LastName')
            "
          ></v-text-field>
          <v-select
            v-model="User.membership"
            label="Member Level *"
            attach
            item-text="text"
            item-value="id"
            :items="MemberShipLevelArray"
            :error-messages="
              getErrorMessage('membership', 'membership')
            "
          ></v-select>
          <v-select
            v-model="User.Language"
            label="Language *"
            attach
            :items="languageArray"
            :error-messages="
              getErrorMessage('Language', 'Language')
            "
          ></v-select>
          <v-text-field
            v-model="User.Email"
            label="Email address *"
            autocomplete="off"
            :error-messages="
              getErrorMessage('Email', 'Email')
            "
          ></v-text-field>
          <v-text-field
            v-model="User.Phone"
            label="Phone number *"
            maxlength="17"
            minlength="7"
            :error-messages="
              getErrorMessage('Phone', 'Phone')
            "
          ></v-text-field>
          <v-select
            v-model="User.Country"
            :items="filteredCountries"
            label="Country *"
            class="pt-3"
            :error-messages="
              getErrorMessage('Country', 'Country')
            "
          >
          </v-select>
          <v-text-field
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2"
            v-model="User.Password"
            label="Password *"
            autocomplete="new-password"
            :error-messages="
              getErrorMessage('Password', 'Password')
            "
          ></v-text-field>
        </v-container>
      </v-form>
      <div class="d-flex justify-end mt-3">
        <v-btn
          color="#C4C4C4"
          class="white--text py-5 px-8 mb-6"
          depressed
          @click="close()"
          ><span class="text_style">Cancel</span>
        </v-btn>
        <v-btn
          color="primary"
          class="white--text py-5 px-8 ml-4"
          depressed
          :disabled="btnloader"
          @click="save()"
          ><span v-if="btnloader != true"> Save</span>
          <v-progress-circular
            indeterminate
            size="20"
            v-else
            class="px-5"
            color="white"
            v-show="btnloader"
          ></v-progress-circular
        ></v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
// import UserimageuploaderComponent from "./userimageuploader.component.vue";
// import VueDropify from "vue-dropify";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { required, email,
  // alpha,
  // numeric,
  minLength,
  maxLength, } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
// const alphaWithSpaces = (value) => {
//   if (!value) return true;
//   return /^[A-Za-z\s]+$/.test(value);
// };
const alphaWithSpacesAndSpecialChars = (value) => {
  if (!value) return true;
  return /^[A-Za-z\s!@#$%^&*()_+\-=[\]{};'’:"\\|,.<>/?áàãâäåāăąçćĉċčðďèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĵķĺļľłńņňŋòóôõöøōŏőœñŕŗřśŝşšţťŧùúûüũūŭůűųŵýÿŷźżžÁÀÃÂÄÅĀĂĄÇĆĈĊČÐĎÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĴĶĹĻĽŁŃŅŇŊÒÓÔÕÖØŌŎŐŒŔŖŘŚŜŞŠŢŤŦÙÚÛÜŨŪŬŮŰŲŴÝŸŶŹŻŽ\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]+$/.test(value);
  // to allow spaces, special char, latin char. Japanese characters (Kanji, Hiragana and Katakana scripts)
};
const phoneWithSpecialChars = (value) => {
  if (!value) return true;
  return /^[0-9+\-\s()]+$/.test(value);
};
export default {
  mixins: [validationMixin],
  name: "editteamcomponent",
  components: {
    // UserimageuploaderComponent,
    // VueDropify,
    // vueDropzone: vue2Dropzone,
  },
  validations: {
    User: {
      FirstName: { required, alpha: alphaWithSpacesAndSpecialChars },
      LastName: { required, alpha: alphaWithSpacesAndSpecialChars },
      Email: { required, email },
      Phone: { required, numeric:phoneWithSpecialChars, minLength: minLength(7),
        maxLength: maxLength(17), },
      Country: {
        required,
      },
      Password: {
        required, minLength: minLength(8),
      },
      Language: {
        required,
      },
      membership: {
        required,
      },
    },
  },
  data() {
    return {
      show2: false,
      MemberShipLevelArray: [{ text: "Starter - $0", id: 1, amount: 0 }],
      languageArray: ["English", "Japanese", "German", "Portuguese"],
      btnloader: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        addRemoveLinks: true,
      },
      User: {
        Language: null,
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: null,
        Password: null,
        membership: null,
        ProfileImageFile: "",
        WebpageURL: "",
        Specializations: "",
        Region: "",
        Country: "",
        Bio: "",
        IntroDescription: "",
        AccountType: 1,
      },
      valid: false,
      firstname: "",
      lastname: "",
      PhoneNumber: "",
      email: "",
      memberlevel: "",
      streetaddress1: "",
      streetaddress2: "",
      regions: [
        'Africa', 'Asia', 'Caribbean', 'Europe', 'North America', 'Oceania', 'South America'
      ],
      regionCountryMap: {
        'Africa': [
          'Algeria', 'Angola', 'Benin', 'Botswana', 'Burkina Faso', 'Burundi', 'Bouvet Island',
          'Cabo Verde', 'Cameroon', 'Central African Republic', 'Chad', 'Comoros', 
          'Congo (the Democratic Republic of the)', 'Congo (the)', "Côte d'Ivoire", 
          'Djibouti', 'Egypt', 'Equatorial Guinea', 'Eritrea', 'Eswatini', 'Ethiopia', 
          'Gabon', 'Gambia (the)', 'Ghana', 'Guinea', 'Guinea-Bissau', 'Kenya', 
          'Lesotho', 'Liberia', 'Libya', 'Madagascar', 'Malawi', 'Mali', 'Mauritania', 
          'Mauritius', 'Morocco', 'Mozambique', 'Namibia', 'Niger (the)', 'Nigeria', 
          'Rwanda', 'Sao Tome and Principe', 'Senegal', 'Seychelles', 'Sierra Leone', 
          'Somalia', 'South Africa', 'South Sudan', 'Sudan (the)', 'Tanzania, United Republic of', 
          'Togo', 'Tunisia', 'Uganda', 'Zambia', 'Zimbabwe',
          'Western Sahara', 'Réunion', 'Mayotte', 'Saint Helena, Ascension and Tristan da Cunha'
        ],
        'Asia': [
          'Afghanistan', 'Armenia', 'Azerbaijan', 'Bahrain', 'Bangladesh', 'Bhutan', 
          'Brunei Darussalam', 'Cambodia', 'China', 'Cyprus', 'Georgia', 'India', 
          'Indonesia', 'Iran (Islamic Republic of)', 'Iraq', 'Israel', 'Japan', 
          'Jordan', 'Kazakhstan', 'Kuwait', 'Kyrgyzstan', "Lao People's Democratic Republic (the)", 
          'Lebanon', 'Malaysia', 'Maldives', 'Mongolia', 'Myanmar', 'Nepal', 'Oman', 
          'Pakistan', 'Palestine, State of', 'Philippines', 'Qatar', 'Republic of North Macedonia', 
          'Russian Federation (the)', 'Saudi Arabia', 'Singapore', 'South Korea', 'Sri Lanka', 
          'Syrian Arab Republic', 'Taiwan', 'Tajikistan', 'Thailand', 'Timor-Leste', 
          'Turkey', 'Turkmenistan', 'United Arab Emirates (the)', 'Uzbekistan', 'Viet Nam', 'Yemen',
          'Hong Kong', 'Macao', "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", 'British Indian Ocean Territory (the)', 'Christmas Island', 'Cocos (Keeling) Islands (the)'
        ],
        'Caribbean': [
          'Antigua and Barbuda', 'Bahamas (the)', 'Barbados', 'Cuba', 'Cayman Islands (the)', 'Dominica', 
          'Dominican Republic (the)', 'Grenada', 'Haiti', 'Jamaica', 'Saint Kitts and Nevis', 
          'Saint Lucia', 'Saint Vincent and the Grenadines', 'Trinidad and Tobago',
          'Anguilla', 'Aruba', 'Bermuda', 'Bonaire, Sint Eustatius and Saba', 'Curaçao',
          'Guadeloupe', 'Martinique', 'Montserrat', 'Puerto Rico', 'Saint Barthélemy',
          'Saint Martin (French part)', 'Saint Pierre and Miquelon', 'Sint Maarten (Dutch part)',
          'Turks and Caicos Islands (the)', 'Virgin Islands (British)', 'Virgin Islands (U.S.)'
        ],
        'Europe': [
          'Albania', 'Andorra', 'Austria', 'Belarus', 'Belgium', 'Bosnia and Herzegovina', 
          'Bulgaria', 'Croatia', 'Czechia', 'Denmark', 'Estonia', 'Finland', 'France', 
          'Germany', 'Greece', 'Hungary', 'Iceland', 'Ireland', 'Italy', 'Latvia', 
          'Liechtenstein', 'Lithuania', 'Luxembourg', 'Malta', 'Moldova (the Republic of)', 
          'Monaco', 'Montenegro', 'Netherlands', 'Norway', 'Poland', 'Portugal', 'Romania', 
          'San Marino', 'Serbia', 'Slovakia', 'Slovenia', 'Spain', 'Sweden', 'Switzerland', 
          'Ukraine', 'United Kingdom', 'Vatican City',
          'Faroe Islands (the)', 'Gibraltar', 'Guernsey', 'Isle of Man', 'Jersey',
          'Svalbard and Jan Mayen', 'Åland Islands', 'Holy See (the)'
        ],
        'North America': [
          'Canada', 'Costa Rica', 'Mexico', 'United States', 'Belize',
          'Bermuda', 'Greenland', 'Guatemala', 'El Salvador', 'Honduras', 'Saint Pierre and Miquelon', 'Panama', 'USA Minor Outlying Islands'
        ],
        'Oceania': [
          'Australia', 'Fiji', 'Kiribati', 'Marshall Islands (the)', 'Micronesia (Federated States of)', 
          'Nauru', 'New Zealand', 'Palau', 'Papua New Guinea', 'Samoa', 'Solomon Islands', 
          'Tonga', 'Tuvalu', 'Vanuatu',
          'American Samoa', 'Cook Islands (the)', 'French Polynesia', 'Guam', 'New Caledonia',
          'Niue', 'Norfolk Island', 'Northern Mariana Islands (the)', 'Pitcairn', 'Tokelau',
          'Wallis and Futuna', 'French Southern Territories (the)', 'Heard Island and McDonald Islands'
        ],
        'South America': [
          'Argentina', 'Bolivia (Plurinational State of)', 'Brazil', 'Chile', 'Colombia', 
          'Ecuador', 'Guyana', 'Paraguay', 'Peru', 'Suriname', 'Uruguay', 'Venezuela (Bolivarian Republic of)',
          'Falkland Islands (the) [Malvinas]', 'French Guiana', 'South Georgia and the South Sandwich Islands'
        ]
      },
      
      filteredCountries: [],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["super admin", "admin"],
    };
  },
  mounted() {
    // Initialize the country list from regionCountryMap so Country dropdown shows all mapped countries
    this.filteredCountries = Object.values(this.regionCountryMap).flat();
  },
  watch: {
    'User.Country': {
      handler(newCountry) {
        if (newCountry) {
          // Derive region from selected country using the mapping
          const foundRegion = Object.keys(this.regionCountryMap).find(r =>
            this.regionCountryMap[r].includes(newCountry)
          );
          this.User.Region = foundRegion || "";
        } else {
          this.User.Region = "";
        }
      }
    }
  },
  methods: {
    getErrorMessage(fieldName) {
      const errorMessages = {
        FirstName: {
          required: "First Name is required",
          alpha: "First Name only contains alphabetic characters.",
        },
        LastName: {
          required: "Last Name is required",
          alpha: "Last Name only contains alphabetic characters.",
        },
        Email: {
          required: "Email is required",
          email: "Invalid email address.",
        },
        Phone: {
          required: "Phone number is required",
          numeric: "Phone number should be only numeric characters",
          minLength: "Phone number should be minimum of 7 digits",
          maxLength: "Phone number should be maximum of 12 digits",
        },
        Country:{
          required:"Country is required",
        },
        Password: {
          required: "Password is required",
          minLength: "Password should be a minimum of 8 characters.",
        },
        Language:{
          required: "Language is required",
        },
        membership:{
          required: "Membership is required",
        },
        
      };
      const errorField = this.$v.User[fieldName];
      if (!errorField.$dirty) return null;
      const errors = [];
      Object.keys(errorField.$params).forEach((param) => {
        if (!errorField[param]) {
          errors.push(errorMessages[fieldName][param]);
        }
      });
      return errors.length ? errors[0] : null;
    },
    SetImage(file) {
      console.log(file);
      this.User.ProfileImageFile = file;
    },
    close() {
      this.$emit("close");
      this.$v.$reset();
      this.User = {
        Language: null,
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: null,
        Password: null,
        membership: null,
        ProfileImageFile: "",
        WebpageURL: "",
        Specializations: "",
        Country: "",
        Bio: "",
        IntroDescription: "",
        AccountType: 1,
      };
    },
    
    save() {
      this.$v.User.$touch();
      if (this.$v.User.$invalid) {
        return;
      }
      this.User.UserName = `${this.User.Email.split("@")[0]}`;
      this.formData = new FormData();
      this.formData.append("ProfileImageFile", this.User.ProfileImageFile);
      this.formData.append("UserName", this.User.UserName);
      this.formData.append("FirstName", this.User.FirstName);
      this.formData.append("LastName", this.User.LastName);
      this.formData.append("Email", this.User.Email);
      this.formData.append("Phone", this.User.Phone);
      this.formData.append("Password", this.User.Password);
      this.formData.append("Language", this.User.Language);
      this.formData.append("WebpageURL", this.User.WebpageURL);
      this.formData.append("Specializations", this.User.Specializations);
      this.formData.append("Region", this.User.Region);
      this.formData.append("Country", this.User.Country);
      this.formData.append("MembershipId", this.User.membership);
      this.formData.append("Bio", this.User.Bio);
      this.formData.append("IntroDescription", this.User.IntroDescription);
      this.formData.append("LoginAction", "signup");
      this.formData.append("SubscribeNewsLetter", true);
      this.formData.append("AcceptTermCondittions", true);
      this.formData.append("AccountType", this.User.AccountType.toString());
      this.formData.append("isAdminCreatedUser", true);
      this.btnloader = true;
      this.$store.dispatch("SignupUser", this.formData).then(() => {
        this.btnloader = false;
        this.close();
        this.$swal.fire({
          // toast: true,
          // position: "top-end",
          icon: "success",
          title: "New User Added Successfully",
          showConfirmButton: false,
          timer: 3000,
        });
        const obj = {
          page: 1,
          pagesize: "10",
          search: "",
          filters: [],
        };
        this.$store.dispatch("GetAllUser", obj);
      }).catch(() => {
        this.btnloader = false;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Email Already Exist",
          showConfirmButton: false,
          timer: 3000,
        });
      });
      // setTimeout(() => {
      //   this.btnloader = false;
      // }, 100);
      // setTimeout(() => {
      //   this.close();
      //   this.btnloader = false;
      //   this.$swal.fire({
      //       toast: true,
      //       position: "top-end",
      //       icon: "success",
      //       title: "User Added Successfully",
      //       showConfirmButton: false,
      //       timer: 1500,
      //     });
      //   this.snackbar = true;
      // }, 2000);
    },
  },
};
</script>

<style scoped>
.vue-dropzone {
  padding: 0;
  background: transparent;
  border-style: dashed;
}
</style>
